import { Preview } from "@creatomate/preview";
import { deepClone } from "app/utils";

const deleteElement = async (preview: Preview, elementId?: string): Promise<void> => {
  if (!preview.state) return;
  if (!elementId) return;

  // Clone the current renderer state
  const state = deepClone(preview.state);

  // Remove the element
  state.elements = state.elements.filter((element: any) => element.source.id !== elementId);

  // Set source by the mutated state
  await preview.setSource(preview.getSource(state), true);
};

export default deleteElement;
